export function Lopetus() {
  return (
    <div className="container">
      <h1>Hauskaa wappua!</h1>
      <p>© Polyteknikkojen Orkesteri 1922-2022</p>
    </div>
  );
}
